// extracted by mini-css-extract-plugin
module.exports = {"button":"AppStreamButton_button__2XunV","selector":"AppStreamButton_selector__m3JZS","blur":"AppStreamButton_blur__2-Xtx"};